import { ACCESS_CODE_LOADING, ACCESS_CODE_CORRECT, SERVICE_HEADER, ACCESS_CODE_ERROR, DOWNLOAD_LOADING, ACCESS_CODE_INCORRECT, DOWNLOAD_SUCCESS, DIGITAL_DOWNLOAD_RESET, DOWNLOAD_ERROR } from "./Consts"
import axios from 'axios';
import Config from "../config/Configs";
import { launchPostInTab } from "../utils/utils";

export const validateDownload = (accessCode) => {
	return (dispatch) => {
		dispatch({
			type: ACCESS_CODE_LOADING
		});
		console.log(Config)
		axios.post(Config.ddVerifyAccessCode, { accessCode }, { headers: SERVICE_HEADER })
			.then((res) => {
				console.log(res.data);

				const data = res.data;
				if (data.status) {
					dispatch({
						type: ACCESS_CODE_CORRECT,
						payload: {...data, accessCode}
					})
				} else if (data.error) {
					dispatch({
						type: ACCESS_CODE_INCORRECT,
						payload: data
					})
				} else {
					dispatch({
						type: ACCESS_CODE_ERROR,
						payload: data
					})
				}
			})
			.catch((err) => {
				dispatch({
					type: ACCESS_CODE_ERROR,
					payload: {
						error: err,
						errorMessage: err.message
					}
				})
			})
	}
}

export const downloadResourceUpdate = (payload) => {
	return (dispatch) => {
		launchPostInTab(Config.ddUpdate, { accessCode:payload.accessCode }, Config.ddUpdate)
		dispatch({
			type: DOWNLOAD_SUCCESS, 
			payload
		});
	}
}
export const resetData = () => ({
	type: DIGITAL_DOWNLOAD_RESET
})